// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CsvExporterController from "./csv_exporter_controller"
application.register("csv-exporter", CsvExporterController)

import MapController from "./map_controller"
application.register("map", MapController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
